// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__bJxdg","infoBtn":"quickbooks_infoBtn__3Gr11","formBox":"quickbooks_formBox__3vL5x","formFooter":"quickbooks_formFooter__2SPz5"};